import Block from '../../../../_base/src/components/block'

import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

/**
 * Base class for blocks that fade their content up as it scrolls into view,
 * matching the global [data-reveal-group] animation. Not a block of its own.
 */
export default class ContentReveal extends Block {
	static distance = '2em'
	static delay = 0.2
	static duration = 0.8
	static stagger = 0.1
	static ease = 'power4.inOut'
	static start = 'top 90%'

	constructor($el) {
		super($el)

		if (!this.canReveal() || !this.isAnimated()) {
			return
		}

		gsap.registerPlugin(ScrollTrigger)

		this.initContentReveal()
	}

	// override to skip the reveal on specific variants of a block
	canReveal() {
		return true
	}

	isAnimated() {
		return (
			$('.animation').length > 0 &&
			!window.matchMedia('(prefers-reduced-motion: reduce)').matches
		)
	}

	// fade the content of every item up as it scrolls into view
	initContentReveal() {
		this.$el.findElement('item').each((index, element) => {
			const item = $(element)
			const content = this.findIn(item, 'title').add(this.findIn(item, 'text'))

			if (content.length === 0) {
				return
			}

			gsap.set(content, { y: this.constructor.distance, autoAlpha: 0 })

			ScrollTrigger.create({
				trigger: this.findIn(item, 'content'),
				start: this.constructor.start,
				once: true,
				onEnter: () =>
					gsap.to(content, {
						y: 0,
						autoAlpha: 1,
						delay: this.constructor.delay,
						duration: this.constructor.duration,
						stagger: this.constructor.stagger,
						ease: this.constructor.ease,
						// drop the inline styles so the content keeps its own styling
						onComplete: () => gsap.set(content, { clearProps: 'all' }),
					}),
			})
		})
	}

	findIn(item, element) {
		return item.find(`.${this.constructor.title}__${element}`)
	}
}
